import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetPreWork } from 'hooks/useWidgetState'
import ErrorMessage from 'components/share/ErrorMessage'
import { SentenceFingerprintRetrievalResult } from 'schemas/SentenceFingerprintRetrievalResultSchema'
import { DocumentFingerprintRetrievalResult } from 'schemas/DocumentFingerprintRetrievalResultSchema'
import { isEmpty } from 'lodash'

const StreamWidgetEmptyResultGuard: WidgetGuard = ({ widgetId, children }): React.ReactElement => {
  const preWork = useDashboardWidgetPreWork<
    DocumentFingerprintRetrievalResult | SentenceFingerprintRetrievalResult
  >(widgetId)
  const { t } = useTranslation()
  const { fingerprints } = preWork[0].results![0].data

  if (isEmpty(fingerprints)) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }

  return children
}

export default StreamWidgetEmptyResultGuard
